<template>
  <div class="register">
    <div class="register__top">
      <span class="register__title">
        REJESTRACJA
      </span>
      <span
        class="register__close"
        @click="closeModal"
        v-on:keyup.enter="closeModal"
        tabindex="0"
        aria-label="Zamknij"
      />
    </div>
    <div class="register__flex">
      <div class="register__container register__container--inputs">
        <span
          class="register__title"
          tabindex="0"
          aria-label="Załóż konto"
        >
          Załóż konto
        </span>
        <LoginModalInput
          type="login"
          placeholder="Login"
          v-model="login"
          tabindex="0"
          aria-label="Login"
        />
        <LoginModalInput
          type="email"
          placeholder="E-mail"
          v-model="email"
          tabindex="0"
          aria-label="email"
          />
        <LoginModalInput
          type="password"
          placeholder="Hasło"
          v-model="password"
          tabindex="0"
          aria-label="Hasło"
        />
        <LoginModalInput
          type="password--repeat"
          placeholder="Powtórz hasło"
          v-model="repeatPassword"
          tabindex="0"
          aria-label="Powtórz hasło"
        />
      </div>
    </div>
    <span
      class="register__invalid"
      tabindex="0"
      :aria-label="showErrorInfo"
    >
      {{showErrorInfo}}
    </span>
    <div class="register__buttons">
      <SelectButton buttonName="Rejestracja" :action="register" />
      <button
        class="register__cancel"
        @click="closeModal"
        v-on:keyup.enter="closeModal"
        tabindex="0"
        aria-label="Anuluj"
      >
        anuluj
      </button>
    </div>
  </div>
</template>

<script>
import SelectButton from "@/ui/SelectButton.vue";
import LoginModalInput from "@/ui/LoginModalInput.vue";
import mixin from '../mixin';

export default {
  mixins: [mixin],
  components: {
    SelectButton,
    LoginModalInput
  }
};
</script>

<style scoped lang="scss">
.register {
  /* width: 44.375rem; */
    width: 31.875rem;

  background-color: #ffffff;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
 &__invalid {
   color: red;
   margin: 0.2rem 0;
   padding: 0rem 1.5rem;
 }
  &__buttons {
    width: 20%;
  }

  &__top {
    height: 3rem;
    width: 100%;
    background-image: linear-gradient(to right, #df2860, #af2f82);
    position: relative;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  display: flex;
    align-items: center;

  }
  &__title {
    font-family: 'Poppins';
    color: white;
    margin-left: 1rem;

  }
  &__flex {
    display: flex;
    width: 100%;
    justify-content: center;
  }
  &__close {
    color: #fff;
    font-size: 30px;
    position: absolute;
    top: 1rem;
    right: 1rem;
    cursor: pointer;

    width: 1.25rem;
    height: 1.25rem;
    display: block;
    background-image: url("~@/assets/loginModal__close.png");
    background-size: cover;
    background-position: center;
  }
  &__label {
    visibility: hidden;
  }
  &__container {
    width: 50%;
    margin-top: 2rem;
    &--social {
      padding-left: 7.5%;
    }
    &--inputs {
      padding-right: 3%;
    }
  }
  &__input {
    width: 94%;
    height: 2.875rem;
    border: none;
    border-radius: 5px;
    background-color: #d0d0e0;
    margin-bottom: 0.875rem;
    padding-left: 17%;
    font-family: "Poppins", sans-serif;
    color: #2c253f;
    box-sizing: border-box;
  }

  .social {
    &__checkbox {
      margin: 0;

      &:hover {
        cursor: pointer;
      }
    }
    &__remember {
      display: flex;
      align-items: center;
      font-size: 11px;
    }
    &__forgot {
      font-size: 11px;
      &:hover {
        text-decoration: underline;
        cursor: pointer;
      }
    }
    &__label {
      margin-left: 0.5rem;
      &:hover {
        cursor: pointer;
      }
    }
  }
  &__submit {
    width: 25%;
    height: 2.5rem;
    font-size: 1rem;
    text-transform: uppercase;
    background-image: linear-gradient(to right, #df2860, #af2f82);
    border: none;
    border-radius: 5px;
    color: #fafafa;
    letter-spacing: 0.8px;
    margin-top: 2rem;
    cursor: pointer;
    &:hover {
      color: #f8a7dc;
    }
    &--register {
      width: auto;
      padding: 0 1rem;
      margin-top: 1rem;
    }
  }
  &__cancel {
    width: 100%;
    height: 2.5rem;
    font-size: 1rem;
    text-transform: uppercase;
    border: none;
    border-radius: 5px;
    color: #0f1626;
    letter-spacing: 0.8px;
    margin-bottom: 1rem;

    background-color: transparent;
    cursor: pointer;
    &:hover {
      background-color: darken(#fff, 10%);
    }
  }
  .social__link {
    width: 14.6875rem;
    height: 2.8rem;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    display: block;
    &--facebook {
      background-image: url(~@/assets/fb__sign.png);
    }
    &--google {
      background-image: url(~@/assets/google__sign.png);
      margin-bottom: 0.875rem;
    }
  }
}
</style>
